import { Link } from "gatsby";
import React from "react";

export default function ThankYouPopup({ open, setOpen }) {
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      {open && (
        <React.Fragment>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[200] outline-none focus:outline-none font-primary">
            <div className="relative  my-6 mx-auto md:w-[32rem] w-80">
              <div className="border-0 p-8 rounded-lg shadow-lg relative flex text-black flex-col gap-5 w-full bg-white outline-none focus:outline-none ">
                <img
                  src="https://tomedes.gumlet.io/frontend/images/home-en/popup_assets/check_dark.svg"
                  alt="check_dark"
                  className="w-18 block mx-auto mt-2"
                />
                <h3 className="text-3xl font-semibold text-center font-secondary ">
                  <span className="">Thank</span> You!
                </h3>
             
                <p
                  className="font-opensans text-[#0A2641] md:text-lg text-sm font-medium leading-relaxed text-center swal2-html-container"
                  id="swal2-content"
                >
                  We'll reply in a few minutes. <br />
                  Meanwhile, try the <Link  to="https://www.tomedes.com/tools"
                    className="text-lightBlue underline-offset-4 underline" target="_blank">Tomedes free AI tools </Link>to improve accuracy, speed, and cost-efficiency in translation.
                  {/* <Link
                    to="/tools/pre-translation"
                    className="text-lightBlue underline-offset-4 underline"
                  >
                    Pre Translation Toolkit
                  </Link> */}
                </p>

                <button
                  className="block mx-auto my-2 text-white bg-orange rounded-lg text-lg w-24 px-6 py-3 font-medium outline-none focus:outline-none ease-linear transition-all duration-150"
                  type="button"
                  onClick={handleClose}
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </React.Fragment>
      )}
    </>
  );
}
